/**
 * Messages for the promotion error codes shared by every code-entry box: the ferry and event carts
 * and the purchase page. Kept in one place so the wording cannot drift between them.
 */
export const PROMOTION_USAGE_LIMIT_REACHED_MESSAGE = 'This promotion is no longer available.';
export const PROMOTION_PARTIALLY_APPLIED_USAGE_LIMIT_MESSAGE =
	'This promotion only had enough uses left for some of your bookings.';
export const PROMOTION_NOT_ELIGIBLE_CUSTOMER_MESSAGE = "This promotion isn't available for this customer.";
